import { System } from '../core/System';
import {
  AnimationComponent,
  AnimationState,
} from '../components/AnimationComponent';
import { SpriteComponent } from '../components/SpriteComponent';

/**
 * AnimationSystem handles sprite animation updates
 * Updates animation frames based on timing and state
 */
export class AnimationSystem extends System {
  constructor() {
    super();
    this.registerRequiredComponent(AnimationComponent);
    this.registerRequiredComponent(SpriteComponent);
  }

  public update(deltaTime: number): void {
    for (const entity of this.getEntities()) {
      const animation = this.componentManager.getComponent(
        entity,
        AnimationComponent
      ) as AnimationComponent;
      const sprite = this.componentManager.getComponent(
        entity,
        SpriteComponent
      ) as SpriteComponent;

      if (!animation.isPlaying) continue;

      // Update frame timing
      animation.frameTime += deltaTime;

      // Check if it's time to advance to next frame
      if (animation.frameTime >= animation.animationSpeed) {
        animation.frameTime = 0;

        const textures = animation.animations.get(animation.currentState);
        if (!textures || textures.length === 0) continue;

        // Advance frame
        animation.currentFrame++;

        // Handle looping
        if (animation.currentFrame >= textures.length) {
          if (animation.loop) {
            animation.currentFrame = 0;
          } else {
            animation.currentFrame = textures.length - 1;
            animation.isPlaying = false;
          }
        }

        // Update sprite texture
        const currentTexture = animation.getCurrentTexture();
        if (currentTexture) {
          sprite.texture = currentTexture;
        }
      }
    }
  }

  /**
   * Change animation state for an entity
   */
  public changeAnimationState(entity: any, newState: AnimationState): void {
    const animation = this.componentManager.getComponent(
      entity,
      AnimationComponent
    ) as AnimationComponent;
    if (!animation) return;

    if (animation.currentState !== newState) {
      animation.currentState = newState;
      animation.currentFrame = 0;
      animation.frameTime = 0;
      animation.isPlaying = true;

      // Update sprite texture immediately
      const sprite = this.componentManager.getComponent(
        entity,
        SpriteComponent
      ) as SpriteComponent;
      if (sprite) {
        const currentTexture = animation.getCurrentTexture();
        if (currentTexture) {
          sprite.texture = currentTexture;
        }
      }
    }
  }
}
